import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FfEndPoints } from '../../../ff-endpoints';

@Component({
    selector: 'app-empty-lrs',
    templateUrl: './empty-lrs.component.html',
    styleUrls: ['./empty-lrs.component.scss']
})

export class EmptyLrsComponent {
    private readonly router: Router;
    constructor(
        router: Router,
    ) {
        this.router = router;
    }

    public goToInvestNowPage() {
        this.router.navigate([FfEndPoints.PORTFOLIO]);
    }
}